import { render, staticRenderFns } from "./financial-aid-article.vue?vue&type=template&id=7134c95f&scoped=true"
import script from "./financial-aid-article.vue?vue&type=script&lang=js"
export * from "./financial-aid-article.vue?vue&type=script&lang=js"
import style0 from "./financial-aid-article.vue?vue&type=style&index=0&id=7134c95f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7134c95f",
  null
  
)

export default component.exports